import { LAWLEX_API_NOT_CALLED } from '../constant';
export default () => ({
    loading: false,
    showModal: false,
    lawlexApiLoaded: LAWLEX_API_NOT_CALLED,
    lawlexUnlocked: false,
    lawlexLoading: false,
    showLawlexLockIcon : false,
});